export const NetworkContextName = 'NetWork'
